import React from "react";
import { connect } from "react-redux";
import Request, {API_URL} from '../../request'
import {Card, Row, Col, Button} from 'antd'
import moment from "moment";
import _ from 'lodash'
import Timer from "../../components/Timer/Timer";
// import Timer from "../Timer/Timer";
import { Link } from "react-router-dom";

class AssignedTrainings extends React.Component {
    state = {
        visible: true,
        withdrawReason: '',
        withdrawDate: '',
        showAddTaskForm: false,
        showTaskListForm: false,
        allUsers: [],
        weekendsVisible: true,
        currentEvents: [],
        allEvents: [],
        startDate: '',
        endDate: '',
        filterStatus: 'Pending',
        filterPriority: '',
        assignById: '',
        assignId: '',
        counsellors: [],
        localUser:{},
        trackAllUserAttendence:null
    }


    async getCompanyDetails() {
        let response  = await Request.getCompanySetting({businessId:this.state.localUser.businessId})
        this.setState({trackAllUserAttendence:response.trackAllUserAttendence})
    }

    async componentDidMount() {
        let localUser = JSON.parse(localStorage.getItem("user"));
        let { data: allUsers } = await Request.loadDeskUser({
            results: 10000,
            active: true,
            userBranch: localUser ? localUser.userBranch : null,
            userId: localUser._id,
        });
        this.setState({ allUsers:allUsers, assignId:localUser._id,localUser:localUser });
        this.getCalendarData()
        this.getCompanyDetails()
    }

    getCalendarData = async() => {
        let startDate = moment().format('YYYY-MM-DD')
        let endDate = moment().format('YYYY-MM-DD')

        this.setState({startDate, endDate})
        let params = {};
        
        // params.dueDate = {
        //     $gte: startDate,
        //     $lte: endDate
        // };
        if(this.state.filterStatus) {
            params.status = this.state.filterStatus
        }
        if(this.state.filterPriority) {
            params.priority = this.state.filterPriority
        }
        if(this.state.assignById) {
            params.assignById = this.state.assignById
        }
        if(this.state.assignId) {
            params.assignId = this.state.assignId
        }
        let response = await Request.getAllTaskListAssignToUser(params);
        let events = [];
        _.each(response.data, (event) => {
                const startDateTime = moment(event.startDate).format('YYYY-MM-DD') + ' ' + event.startTime
                events.push({
                    id: event._id,
                    title: event.taskTitle,
                    assignedBy:event.createdByUser && event.createdByUser.name,
                    priority: event.priority,
                    status: event.status,
                    start: (event.startDate?startDateTime:event.dueDate),
                    dueDate:event.dueDate
                })
        })
        this.setState({allEvents: events});
    }

    render() {
        let {allEvents} = this.state
        return (
            <div>
                <Row gutter={16} style={{marginBottom:"20px"}}>
                    <Col span={this.state.trackAllUserAttendence?12:24} > 
                        <Card bordered={true} title="Pending Tasks" extra={<Link to="/task">View All</Link>} >
                            <table width="100%">
                                <tbody>
                                <tr>
                                    <td>Task Name</td>
                                    <td>Priority</td>
                                    <td>Assigned By</td>
                                    <td>Start Date</td>
                                    <td>Due Date</td>
                                </tr>
                                {allEvents.map((item, index)=>(
                                    <tr key={index}>
                                        <td>{item.title}</td>
                                        <td>{item.priority}</td>
                                        <td>{item.assignedBy}</td>
                                        <td>{moment(item.start).format('DD MMMM YYYY')}</td>
                                        <td>{moment(item.dueDate).format('DD MMMM YYYY')}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </Card>
                    </Col>
                    {this.state.trackAllUserAttendence?
                    <Col span={12}>
                        <Timer />
                    </Col>
                    :null}
                </Row>
                
            </div>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AssignedTrainings)